module.exports = __webpack_public_path__ + "img/5.b7d31123.jpg";